import { Instruction, OpCode } from '../internal.js';
/**
 * Deploy Instruction.
 *
 * Deploys a code bundle. The code bundle must be a map of filename => content.
 */
export class DeployInstruction extends Instruction {
    pkgBuf;
    constructor(pkgBuf) {
        super(OpCode.DEPLOY);
        this.pkgBuf = pkgBuf;
    }
}
/**
 * Deploy Args Serializer object - implements the Serializable interface.
 */
export const DeployArgsSerializer = {
    read(buf) {
        const pkgBuf = buf.readFixedBytes(buf.remaining);
        return new DeployInstruction(pkgBuf);
    },
    write(buf, inst) {
        buf.writeFixedBytes(inst.pkgBuf);
        return buf;
    }
};
